// ============================================================================
// Site-wide configuration & contact details
// ----------------------------------------------------------------------------
// NOTE (Future CMS): sourced from a Sanity "siteSettings" singleton later.
// Single source of truth for company name, contact info, and navigation.
// ============================================================================

import type { NavItem, SiteContact } from "@/types/content";

export const SITE_NAME = "MedCore Research Inc.";

export const SITE_TAGLINE = "Bridging Patient Care and Research";

export const SITE_DESCRIPTION =
  "MedCore Research is a clinical research site management and consulting organization connecting suitable study opportunities with capable clinical sites and supporting quality-focused clinical trial operations.";

export const SITE_URL = "https://medcoreresearch.com";

/** Primary navigation (used by Navbar + Footer quick links). */
export const NAV_ITEMS: NavItem[] = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Therapeutic Areas", path: "/therapeutic-areas" },
  { label: "Our Sites", path: "/our-sites" },
  { label: "Blogs", path: "/blogs" },
  { label: "Contact Us", path: "/contact#contact-form" },
];

/** Company social links, shared by desktop/mobile navigation and footer. */
export const SOCIAL_LINKS = [
  { label: "LinkedIn", icon: "linkedin", href: "https://www.linkedin.com/company/medcore-research-inc/" },
];

export const SITE_CONTACT: SiteContact = {
  companyName: SITE_NAME,
  tagline:
    "Canadian-based clinical research site management & consulting \u2014 bridging patient care and research.",
  email: "support@medcoreresearch.com",
  addressLines: ["Toronto, Ontario", "Canada"],
  hours: [{ days: "Monday \u2013 Friday", time: "9:00 AM \u2013 5:00 PM" }],
  social: SOCIAL_LINKS,
};
